/** Home 用の静的ダミー。ランキングや配信 API は未実装。 */

export interface HomeFeatured {
  id: string;
  badge: string;
  title: string;
  date: string;
  blurb: string;
}

export interface HomeTrendItem {
  id: string;
  title: string;
  tag: string;
}

export interface HomeNewsItem {
  id: string;
  date: string;
  title: string;
  /** モーダル用の説明文 */
  body: string;
}

export const HOME_FEATURED: HomeFeatured = {
  id: 'neo-game',
  badge: 'COMING SOON',
  title: 'NEO GAME TITLE',
  date: '2026.xx.xx',
  blurb: 'EmYu-Ba 発のオリジナルタイトル。詳細は近日公開。',
};

export const HOME_TRENDING: HomeTrendItem[] = [
  { id: 't1', title: 'Pixel Racer', tag: 'Coming Soon' },
  { id: 't2', title: 'Dungeon Bits', tag: 'Coming Soon' },
  { id: 't3', title: 'Sky Cart', tag: 'Coming Soon' },
  { id: 't4', title: 'Retro Arena', tag: 'Coming Soon' },
];

export const HOME_NEWS: HomeNewsItem[] = [
  {
    id: 'n7',
    date: '2026.11.04',
    title: 'セーブステート読込を改善（0.2.16）',
    body:
      'ポーズメニューの手動スロットを 10 個まで表示するようにしました（以前は 4 個までで、取り込んだステートが見えないことがありました）。\n\n' +
      '取り込み時のコア名と実際に起動しているコアが違う場合でも、いったん読込を試すようにしています。サーバにステートが無い場合は、同期だけではスロットは埋まりません。Azure からダウンロードしたファイルを「セーブデータを読み込む」で入れてください。',
  },
  {
    id: 'n6',
    date: '2026.11.04',
    title: 'Azure からのセーブ取り込みを修正（0.2.15）',
    body:
      '以前の Azure 環境からダウンロードしたセーブ（`.state1.bin`）や、ストレージ上の `state-0.bin` 形式を読み込むとステートが消える／スロットがずれることがあった問題を修正しました。\n\n' +
      '取り込み直後にサーバー同期の墓標で ROM ごと消えてしまうケースも防いでいます。ライブラリの「セーブデータを読み込む」で入れ直したあと、My からサーバー同期してください。\n\n' +
      'なおオンプレサーバ側を確認したところ、ミラー時点ではステートファイルが 0 件でした。SRAM だけ移っている場合は、手元のステートファイルの再取り込みが必要です。',
  },
  {
    id: 'n5',
    date: '2026.11.04',
    title: 'セーブステートのサーバー同期を改善（0.2.14）',
    body:
      'オンプレサーバではセーブステートの枚数制限を外しました。これまで SRAM やライブラリだけ同期され、ステートがサーバに載らないことがありました（サーバ上にステートが 0 件の状態）。\n\n' +
      'ゲーム内で手動ステートを保存したあと、My から「サーバー同期」を実行するか、ゲーム終了時の自動同期を待ってください。別端末では同期後、ポーズメニューの「セーブ」から読み込みます。\n\n' +
      '読込直後に画面が古いままに見える不具合も直しています。オートセーブはこれまでどおり端末内のみです。',
  },
  {
    id: 'n4',
    date: '2026.11.04',
    title: 'サーバー同期の不具合を修正（0.2.13）',
    body:
      'オンプレサーバ向けの同期で、セーブやライブラリのアップロードが失敗することがあった問題を修正しました。My から「サーバー同期」を実行できるようになっています。\n\n' +
      'あわせて、同期で取り込んだセーブステートが「別のコア」扱いになり読み込めなくなる不具合も直しています。一度同期し直すか、強リロード後にもう一度ステート読込を試してください。\n\n' +
      'オートセーブはこれまでどおり端末内のみです。ROM 本体はサーバーへ送りません。',
  },
  {
    id: 'n1',
    date: '2026.09.26',
    title: 'EmYu-Ba アップデートのお知らせ（0.2.7）',
    body:
      'ログイン後の入り口を Home ハブに刷新しました。Home / Retro / Games / My から目的の画面へ進めます（Platform は PC・横持ちの上部ナビのみ）。\n\n' +
      'アカウント・サインアウト・サーバー同期は「My」、パッド・表示・BIOS・メモリーカードなどのエミュレーター設定は Retro 内の「設定」に分けました。\n\n' +
      'PC では Home をブラウザ本体のスクロールで読めるようにし、スマホ縦は従来どおりアプリ内スクロールのままです。',
  },
  {
    id: 'n2',
    date: '2026.09.26',
    title: '新機能 Coming Soon',
    body:
      'EmYu-Ba Games（オリジナルゲームの配布・プレイ）と EmYu-Ba Platform（クリエイター向け公開基盤）を準備しています。\n\n' +
      '現在は Coming Soon 画面のみで、プレイや投稿はまだできません。公開までしばらくお待ちください。\n\n' +
      '一方 Retro（エミュレーター）はこれまでどおり、お持ちの ROM をブラウザでプレイできます。',
  },
  {
    id: 'n3',
    date: '2026.09.20',
    title: 'サーバー同期とマルチディスク対応',
    body:
      'セーブ（SRAM・手動ステート）とライブラリ一覧のサーバー同期に対応しています。オートセーブは端末内のみ、ROM 本体はサーバーへ送りません。端末を切り替える前に My から同期するか、ゲーム終了／アプリ切替時の自動同期をご利用ください。\n\n' +
      'PS1 はマルチディスク交換（m3u + Disk Control）、複数枚のメモリーカード切り替え、BIOS 配置の改善にも対応しています。',
  },
];
